import styled from "styled-components";
import { colors, font, radius, shadow } from "../../styles/theme/tokens";

export const FormWrapper = styled.form`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  max-width: 820px;
  margin-bottom: 20px;
  padding: 14px;
  border-radius: ${radius.lg};
  background: ${colors.surface};
  border: 1px solid ${colors.line};
  box-shadow: ${shadow.card};
`;

export const Input = styled.input`
  flex: 1 1 200px;
  min-width: 120px;
  padding: 12px 14px;
  border-radius: ${radius.md};
  border: 1.5px solid ${colors.line};
  background: ${colors.bg};
  font-family: ${font.text};
  font-size: 16px;
  font-weight: 500;
  color: ${colors.ink};
  transition: border-color 0.15s ease, background 0.15s ease;

  &::placeholder {
    color: ${colors.muted};
  }

  &:focus {
    outline: none;
    border-color: ${colors.brand};
    background: ${colors.surface};
  }
`;

export const Button = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 22px;
  border-radius: ${radius.md};
  font-family: ${font.text};
  font-size: 16px;
  font-weight: 800;
  color: #FFFFFF;
  background: ${colors.brand};
  box-shadow: ${shadow.button(colors.brandDeep)};
  cursor: pointer;
  transition: transform 0.08s ease, box-shadow 0.08s ease;

  &:active {
    transform: translateY(3px);
    box-shadow: ${shadow.button("transparent")};
  }

  @media (max-width: 480px) {
    width: 100%;
  }
`;
